import React from "react";
import InfoIcon from "../InfoIcon";
import "./index.css";
import { useTranslation } from "react-i18next";

const getScopeKind = (label) => {
  const text = String(label ?? "").toLowerCase();
  if (text.includes("scope 1")) return "1";
  if (text.includes("scope 2")) return "2";
  if (text.includes("scope 3") || text.includes("s:3")) return "3";
  if (text.includes("outside")) return "outside";
  return "other";
};

const SubItem = ({ label, value, scopes }) => (
  <div className="subitem">
    <span className="subitemspan">
      {label ? `${value} ${label}` : value}
      {scopes && (
        <div className="scopes">
          {scopes.map((scope, scopeIndex) => (
            <span
              key={scopeIndex}
              className={`scope scope--${getScopeKind(scope)}`}
            >
              {scope}
            </span>
          ))}
        </div>
      )}
    </span>
  </div>
);

const TotalBox = ({ title, items, showInfoIcon, infoText, infoText1 }) => (
  <div className="total-box">
    <div className="total-title">
      <h3>{title}</h3>
    </div>
    <div style={{ display: "flex", justifyContent: "center" }}>
      {items.map((item, index) => (
        <div key={index} className="item">
          {item.subtitle ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className="sub-item">
                <h4>{item.subtitle}</h4>
                {showInfoIcon && (
                  <InfoIcon text={index === 0 ? infoText : infoText1} />
                )}
              </div>
              <div className="subitem-box">
                {item.subitems.map((subitem, subIndex) => (
                  <SubItem key={subIndex} {...subitem} />
                ))}
              </div>
            </div>
          ) : (
            <SubItem {...item} />
          )}
        </div>
      ))}
    </div>
  </div>
);

const RightBox = ({ totals, lastUpdated }) => {
  const { t } = useTranslation();
  const safeTotals = Array.isArray(totals) ? totals : [];
  // Lovable: header is always "<left title>" | "Total for the category"
  // (even when the body has multiple blocks).
  const leftHeader = safeTotals[0]?.title || "";
  const rightHeader = "Total for the category";
  return (
    <div className="right-box">
      <div className="right-box__card" style={{ width: "100%" }}>
        <div className="right-box__header">
          <div className="right-box__header-left">{leftHeader}</div>
          <div className="right-box__header-right">{rightHeader}</div>
        </div>
        <div className="right-box__body">
          {safeTotals.map((total, index) => (
            <TotalBox key={index} {...total} />
          ))}
        </div>
        {lastUpdated && (
          <div className="right-box__footer">
            {t("LAST_UPDATED")}: {lastUpdated}
          </div>
        )}
      </div>
    </div>
  );
};

export default RightBox;
